import Typography from './typography';

export { Typography };

export default Typography;
